import { fetchJSON } from '@bonnet/next/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

export default (search) => fetchJSON(cmApiUrl('/rest/lsc/listing'), {
    circuitBreaker: {
        id: 'supplementalSearch',
        timeout: 5000,
        resetTimeout: 30000,
        fallback: {},
    },
    headers: {
        'X-fwd-svc': 'atc',
        'X-CoxAuto-Caller-Id': 'CI2355308',
    },
    credentials: 'same-origin',
    query: { ...search },
});
